import Polyglot from 'node-polyglot';

import { LanguageService } from '/services';
import {
    nl,
    fr,
    en,
    zh,
} from '/copy';

class CopyService {
    static polyglot;

    static getPolyglot = () => {
        if (CopyService.polyglot) {
            return CopyService.polyglot;
        }

        let phrases = {
            [LanguageService.languages.NL]: nl,
            [LanguageService.languages.FR]: fr,
            [LanguageService.languages.EN]: en,
            [LanguageService.languages.ZH]: zh,
        }[LanguageService.getLanguage()];

        CopyService.polyglot = new Polyglot({
            phrases,
        });

        return CopyService.getPolyglot();
    };

    static get = (key, attributes) => {
        const polyglot = CopyService.getPolyglot();

        return polyglot.t(key, attributes);
    };
}

export { CopyService };
